/**
 * PO Line Detail Footer - fixed action bar for the PO line modal (CR-4703).
 *
 * Renders all contextual actions (Review Changes, Propose Change, Critical toggle,
 * Hold toggle, Cancel Change Request) on the left and the Close button on the right.
 *
 * CR-4705 round 2 rework: Accept/Decline are no longer the footer's primary
 * actions for change-request states. Instead a single "Review Changes"
 * button surfaces here whenever the line is awaiting the current viewer's
 * decision, and routes them into the Change Requests tab where the per-
 * field Accept/Reject controls live (added in CR-4688). The button hides
 * once the user is already on that tab to avoid the "click here to go
 * where you already are" anti-pattern.
 */
import type { PurchaseOrderLine } from '../../lib/api';

interface POLineDetailFooterProps {
  line: PurchaseOrderLine;
  // CR-4705: hide the Review Changes button once the user is on the
  // Change Requests tab.
  activeTab: string;
  canToggleCritical: boolean;
  canToggleHold: boolean;
  canShowProposeChange: boolean;
  canShowWorkflowActions: boolean;
  isProposer: boolean;
  onToggleCritical: () => void;
  onToggleHold: () => void;
  onPropose: () => void;
  onSwitchToChangeRequests: () => void;
  onClose: () => void;
}

export function POLineDetailFooter({
  line,
  activeTab,
  canToggleCritical,
  canToggleHold,
  canShowProposeChange,
  canShowWorkflowActions,
  isProposer,
  onToggleCritical,
  onToggleHold,
  onPropose,
  onSwitchToChangeRequests,
  onClose,
}: POLineDetailFooterProps) {
  // Collaboration buttons (Accept/Decline/Propose Change/Critical/Hold/Cancel
  // Change Request) are hidden for this portal instance. Footer keeps only
  // the Close action. Suppress unused-prop warnings — the props are still
  // passed by the parent so the contract is unchanged.
  void line; void activeTab; void canToggleCritical; void canToggleHold; void canShowProposeChange;
  void canShowWorkflowActions; void isProposer;
  void onToggleCritical; void onToggleHold; void onPropose;
  void onSwitchToChangeRequests;
  return (
    <div className="border-t p-4 flex items-center justify-end gap-3 bg-muted/10">
      <button
        onClick={onClose}
        className="px-4 py-2 border border-border rounded-lg hover:bg-muted font-medium"
      >
        Close
      </button>
    </div>
  );
}
